import React from 'react';
import { FormGroup, InputBase } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

const BuyNowCard = ({ buyNowPaymentMethod }) => {
  const {t} = useTranslation();
  return <div>
    <FormGroup className="gpayAndApplePayPaymentMethodWrapper">
      <p>{t('Card_number')}*</p>
      <InputBase
        label={t('Card_number')}
        name="ccname"
        value={`**** **** **** ${buyNowPaymentMethod.card.last4}`}
        variant="outlined"
        placeholder={t('Card_number')}
        required
        disabled={true}
        fullWidth
        inputProps={{
          maxLength: 50
        }}
      />
    </FormGroup>
  </div>
}

export default BuyNowCard
